export interface  UserStoreStateType {
  name: string;
  email: string;
  age: number;
  fullName: string;
  isLoggedIn: boolean;
  isEnrolled: boolean;
  isError: string;
  id: string;
  error: any;
  organizationId: string;
  showWelcome: boolean;
  authorities: Array<string>;
  coursesEnrolled: Array<any>;
  globalUser: {
    firstName: string,
    lastName: string,
    username: string,
    authorities: Array<string>
  };
  firstLogin: boolean;
  image: string;
}

export const UserStoreState: UserStoreStateType = {
  name: '',
  email: '',
  id: '',
  fullName: '',
  age: 0,
  isLoggedIn: false,
  isEnrolled: false,
  isError: '',
  error: null,
  showWelcome: true,
  organizationId: '',
  authorities: [],
  coursesEnrolled: [],
  globalUser: {
    firstName: '',
    lastName: '',
    username: '',
    authorities: []
  },
  firstLogin: false,
  image: ''
};

export interface UserActionType {
  type: string;
  payload: UserStoreStateType;
}
